// components
import BundleCard from "./bundleCard/BundleCard";
import Ripple from "../../ui/spinners/ripple/Ripple";

// images
import noItems from "../../../assets/images/noItems.jpg";

const BundlesGrid = ({ bundles, productsLoading }) => {
  // bundles cards
  const bundlesCards =
    bundles &&
    bundles.map((bundle) => <BundleCard key={bundle.id} bundle={bundle} />);

  // content
  let content;
  if (productsLoading) {
    content = <Ripple className="border-dark-blue" />;
  } else if (bundles?.length === 0) {
    content = (
      <div className="mx-auto w-fit text-center">
        <img src={noItems} alt="no items match your filters" />
        <h2>لا توجد عروض توفير حاليا</h2>
      </div>
    );
  } else {
    content = (
      <section className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {bundlesCards}
      </section>
    );
  }

  ////////////////////////////////

  return <div className="flex flex-col grow relative">{content}</div>;
};

export default BundlesGrid;
